import React from 'react';

import HeaderSectionJobsSearchNoShapes from './HeaderSectionJobsSearchNoShapes/HeaderSectionJobsSearchNoShapes';
import HeaderSectionJobsSearchWhite from './HeaderSectionJobsSearchWhite/HeaderSectionJobsSearchWhite';

const HeaderSection = ({
  isJobsSearchWhiteVersion,
  isJobsSearchWhiteLessFiltersVersion,
  isJobsSearchWhiteNoImageVersion,
}) => {
  if (
    isJobsSearchWhiteVersion ||
    isJobsSearchWhiteLessFiltersVersion ||
    isJobsSearchWhiteNoImageVersion
  ) {
    return (
      <HeaderSectionJobsSearchWhite
        lessFiltersHandheld={isJobsSearchWhiteLessFiltersVersion}
        noImageHandheld={isJobsSearchWhiteNoImageVersion}
      />
    );
  }

  return <HeaderSectionJobsSearchNoShapes />;
};

export default HeaderSection;
